import { useSelector } from 'react-redux';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	isAuthenticated: false,
	token: null,
};

const auth = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		loginSucceeded: (state) => {
			state.isAuthenticated = true;
		},
		logoutSucceeded: (state) => {
			state.isAuthenticated = false;
		},
	},
});

export const { loginSucceeded, logoutSucceeded } = auth.actions;

export const authReducer = auth.reducer;

export const useAuthSelector = () => useSelector(state => state.auth);
